import React from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import slide1 from "../MyFiles/Slide/Slide1.jpg";
import slide2 from "../MyFiles/Slide/Slide2.jpg";
import slide4 from "../MyFiles/Slide/Slide12.jpg";

const Example = () => {
  return (
    <Slide>
      <div className="each-slide-effect">
        <div>
          <img src={slide4} alt="هتل شباویز کیش"></img>
          {/* <React.Fragment><NavLink className='wp-link' to="/home/cermony"><img src={Back} alt='جشن دهه فجر'></img></NavLink></React.Fragment> */}
          {/* <span>Slide 2</span> */}
        </div>
      </div>
      <div className="each-slide-effect">
        <div>
          <img src={slide1} alt="هتل یاس بندرانزلی"></img>
          {/* <React.Fragment><NavLink className='wp-link' to="/home/cermony"><img src={Front} alt='جشن دهه فجر'></img></NavLink></React.Fragment> */}
          {/* <span>برای ثبت نام کلیک کنید</span> */}
        </div>
      </div>
      <div className="each-slide-effect">
        <div>
          <img src={slide2} alt="هتل لعل متین مشهد"></img>
          {/* <React.Fragment><NavLink className='wp-link' to="/home/cermony"><img src={Back} alt='جشن دهه فجر'></img></NavLink></React.Fragment> */}
          {/* <span>Slide 2</span> */}
        </div>
      </div>
    </Slide>
  );
};

export default Example;